import { useEffect } from 'react';

const PLAUSIBLE_DOMAIN = 'nomination.goodstack.org';
const PLAUSIBLE_SCRIPT_URL = 'https://plausible.io/js/script.pageview-props.tagged-events.js';

export const usePlausible = () => {
  useEffect(() => {
    if (process.env.NX_PUBLIC_USE_PLAUSIBLE !== 'true') {
      return;
    }

    const script = document.createElement('script');
    script.defer = true;
    script.id = 'plausible-script';
    script.setAttribute('data-domain', PLAUSIBLE_DOMAIN);
    script.src = PLAUSIBLE_SCRIPT_URL;

    const initScript = document.createElement('script');
    initScript.text = `window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }`;

    document.head.appendChild(script);
    document.head.appendChild(initScript);

    return () => {
      document.head.removeChild(script);
      document.head.removeChild(initScript);
    };
  }, []);
};
